<p-accordionTab [selected]="true" contentStyleClass="info-card" header="Conversation Details">
  <cv-information-entity [value]="data.accountName" label="Account" />
  <cv-information-entity [value]="data.siteName" label="Site" />
  <cv-agent-field />
  <cv-information-entity [value]="data.startDate | date: 'M/d/yyyy h:mm a'" label="Start Time" />
  <cv-information-entity [value]="data.callDuration" label="Duration" />
  <cv-information-entity [value]="data.communicationTypeName" label="Communication Type" />
  <cv-information-entity [value]="data.callDirection" label="Call Direction" />
  <cv-information-entity [isCopiable]="true" [value]="data.conversationId" label="Communication ID" />
  <cv-information-entity [isCopiable]="true" [value]="data.callDetailRecordId" label="Call ID" />
</p-accordionTab>
